import { ContactInfoModel } from "@fs/models/customer/contact.info.model";
import { JobSiteDetailModel } from "@fs/models/customer/job-site-detail-model";
import { CodeTypeModel } from "@fs/models/code-type.model";

export class BillingDetailModel {
    public ID: string;
    public BillingID: string;
    public Type: CodeTypeModel;
    public FirstName: string;
    public LastName: string;
    public CompanyName: string;
    public DisplayName: string;
    public StreetNo: string;
    public City: string;
    public Unit: string;
    public State: string;
    public AccountingNumber: string;
    public ZipCode: string;
    public IsCreditHold: boolean;
    public IsNoTransfer: boolean;
    public IsPoRequired: boolean;
    public CustomerSince: string;
    public LeadSourceComment: string;
    public LeadSourceEmployee: UserModel;
    public LeadSource: LeadSourceModel;
    public AccountRep: UserModel;
    public IsActive: Boolean;
    public IsSameAsJobSite: Boolean;
    public Estimator: UserModel;
    public Division: BillingDetailModel;
    public PaymentTerm: PaymentTermModel;
    public Comment: string;
    public IsAddressVerified: boolean;
    public Contacts: ContactInfoModel[];
    public JobSites: JobSiteDetailModel[];
    public ModifyDate: string;    
    public MappingID: string;
    public constructor(division = true) {
        this.ID = "";
        this.BillingID = "";
        this.Type = new CodeTypeModel();
        this.FirstName = "";
        this.LastName = "";
        this.CompanyName = "";
        this.DisplayName = "";
        this.StreetNo = "";
        this.City = "";
        this.Unit = "";
        this.State = "";
        this.AccountingNumber = "";
        this.ZipCode = "";
        this.IsCreditHold = false;
        this.IsNoTransfer = false;
        this.IsPoRequired = false;
        this.IsSameAsJobSite = true;
        this.CustomerSince = "";
        this.LeadSourceComment = "";
        this.LeadSourceEmployee = new UserModel();
        this.LeadSource = new LeadSourceModel();
        this.AccountRep = new UserModel();
        this.IsActive = false;
        this.Estimator = new UserModel();
        if (division)
            this.Division = new BillingDetailModel(false);
        else
            this.Division = null;
        this.PaymentTerm= new PaymentTermModel();
        this.Comment = "";
        this.IsAddressVerified = false;
        this.Contacts= [];
        this.JobSites=[];
        this.ModifyDate = "";
        this.MappingID = "";
    }
}
export class UserModel {
    ID: string;
    FirstName: string
    LastName: string
    Phone: string
    Email: string
    SecurityRoles: SecurityRoleModel[];
    public constructor(){
        this.SecurityRoles=[];
        this.ID=""
    }
}
export class SecurityRoleModel {
    ID: string
    Name: string
    Description: string
    public constructor(){
        this.ID=""
    }
}
export class LeadSourceModel {
    ID: string
    Name: string
    public constructor(){
        this.ID=""
    }
}
export class PaymentTermModel {
    ID: string
    Name: string
    Description: string
    TermDays: number
    AccountingCode: string
    IsActive:boolean
    public constructor(){
        this.ID=""
    }
}